import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountingLogBank = _resolveComponent("AccountingLogBank")!
  const _component_AccountingLogDocument = _resolveComponent("AccountingLogDocument")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      (_ctx.showAccountingLogBank)
        ? (_openBlock(), _createBlock(_component_AccountingLogBank, {
            key: 0,
            modelValue: _ctx.type,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type) = $event)),
            documentTypes: _ctx.types
          }, null, 8, ["modelValue", "documentTypes"]))
        : (_openBlock(), _createBlock(_component_AccountingLogDocument, {
            key: 1,
            modelValue: _ctx.type,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.type) = $event)),
            documentTypes: _ctx.documentTypes,
            logTypes: _ctx.types
          }, null, 8, ["modelValue", "documentTypes", "logTypes"]))
    ]),
    _: 1
  }))
}